import Footer from "components/components/Footer";
import AutoHideableTitle from "components/components/HeaderComponents/AutoHideableTitle";
import StepBackHeader from "components/components/HeaderComponents/StepBackHeader";
import { useHistory, useLocation } from "react-router-dom";
import { SmartIdAddWizard } from "./Adding/SmartIdAddWizard";
import { SmartIdRemoveWizard } from "./Removing/SmartIdRemoveWizard";
import React from "react";

export function SmartIdManager(props) {
  const history = useHistory();
  const location = useLocation();
  const passedProfileData = location.state?.profileData;
  
  if (!passedProfileData) {
    history.replace('/profileInformation');
    return;
  }
  
  const smartIdAdded = passedProfileData.isSmartIdAdded;



  const navigateToProfile = () => {
    history.push('/profileInformation');
  };

  return (
    <>
      <div className="container page-container">
        <StepBackHeader
          pathName="/profileInformation"
          buttonText="back_to_profile_btn"
        />
        <AutoHideableTitle text={smartIdAdded
          ? "smart_id_manager_page_title_remove_smart_id"
          : "smart_id_manager_page_title_add_smart_id"
        } />
        <div className="card card-full-width">
          <div className="card-content">
            {smartIdAdded
              ? <SmartIdRemoveWizard
                  initialData={{ ...props.initialData, ...passedProfileData }}
                  onNavigateToProfile={navigateToProfile}
                />
              : <SmartIdAddWizard
                  initialData={{ ...props.initialData, ...passedProfileData }}
                  onNavigateToProfile={navigateToProfile}
                />
            }
          </div>
        </div>
      </div>
      <Footer countrySelectionEnabled={false} legalEntity={props.initialData.legalEntityId} />
    </>
  );
}